import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import ReactLenis from "lenis/react";
import "./App.css";
import Navbar from "./components/Navbar";
import ScreenOne from "./pages/ScreenOne";
import ScreenTwo from "./pages/ScreenTwo";
import ScreenThree from "./pages/ScreenThree";
import ScreenFour from "./pages/ScreenFour";
import ScreenFive from "./pages/ScreenFive";
import ScreenSix from "./pages/ScreenSix";
import Footer from "./components/Footer";
import Testimonial from "./pages/Testimonial";
import Planes from "./pages/Planes";
import Booking from "./pages/Booking";
import Appointment from "./pages/appointment/Appointment";
import { useEffect } from "react";
import WeHelpWith from "./pages/WeHelpWith";
import WhatYoullLearn from "./pages/WhatYouLearn";

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    const sectionId = location.pathname.slice(1);
    if (sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  return (
    <ReactLenis root>
      <ScreenOne />
      <ScreenTwo />
      <WeHelpWith />
      <ScreenThree />
      <ScreenFour />
      <Planes />
      <WhatYoullLearn />
      <ScreenFive />
      <Testimonial />
      <ScreenSix />
      <Footer />
    </ReactLenis>
  );
};

const App = () => {
  return (
    <Router>
      <div className="bg-pink-50">
        <Navbar />
        <Routes>
          <Route path="/booking" element={<Booking />} />
          <Route path="/appointment" element={<Appointment />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
